<mat-dialog-content>
  <h2 class="dialog-title-no-padding" mat-dialog-title>Resolve "{{ data.routeName }}" – {{ data.time }}</h2>

  <p class="text-opacity-low">
    {{ data.shuttleCount }} shuttle{{ data.shuttleCount === 1 ? '' : 's' }} currently at {{ data.time }} do not match any scheduled timeslot.
    Reschedule to:
  </p>

  <div class="d-flex flex-column gap-2">
    <button *ngFor="let slot of slotOptions" mat-stroked-button type="button"
      [color]="selectedSlot === slot ? 'primary' : undefined"
      (click)="selectSlot(slot)">
      {{ slot }}
    </button>
  </div>

  <mat-checkbox class="mt-3" [(ngModel)]="notifyCustomer">
    Notify customer
  </mat-checkbox>

  <p *ngIf="error" class="error-text-color">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving" (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selectedSlot || saving" (click)="confirm()">
    {{ saving ? 'Resolving…' : 'Reschedule to: ' + (selectedSlot || '') }}
  </button>
</mat-dialog-actions>
